import type React from 'react'

type Props = {
  className?: string
  width?: number
  height?: number
}

export const PresetBlue: React.FC<Props> = ({
  className,
  width = 96,
  height = 64,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 96 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_61055_74235)">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0H90C93.3137 0 96 2.68629 96 6V58C96 61.3137 93.3137 64 90 64H6C2.68629 64 0 61.3137 0 58V6Z"
          fill="#2F7FEF"
        />
        <g clipPath="url(#clip1_61055_74235)">
          <path
            d="M13 9.5C13 9.08579 13.3358 8.75 13.75 8.75H20.75C21.1642 8.75 21.5 9.08579 21.5 9.5C21.5 9.91421 21.1642 10.25 20.75 10.25H13.75C13.3358 10.25 13 9.91421 13 9.5Z"
            fill="#E8EFF7"
          />
          <g clipPath="url(#clip2_61055_74235)">
            <path
              d="M30 20.8C30 19.1198 30 18.2798 30.327 17.638C30.6146 17.0735 31.0735 16.6146 31.638 16.327C32.2798 16 33.1198 16 34.8 16H81.2C82.8802 16 83.7202 16 84.362 16.327C84.9265 16.6146 85.3854 17.0735 85.673 17.638C86 18.2798 86 19.1198 86 20.8V84.2C86 85.8801 86 86.7202 85.673 87.362C85.3854 87.9265 84.9265 88.3854 84.362 88.673C83.7202 89 82.8802 89 81.2 89H34.8C33.1198 89 32.2798 89 31.638 88.673C31.0735 88.3854 30.6146 87.9265 30.327 87.362C30 86.7202 30 85.8802 30 84.2V20.8Z"
              fill="white"
            />
            <g clipPath="url(#clip3_61055_74235)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M68 35.75C68 36.1642 67.6642 36.5 67.25 36.5H36.75C36.3358 36.5 36 36.1642 36 35.75C36 35.3358 36.3358 35 36.75 35H67.25C67.6642 35 68 35.3358 68 35.75Z"
                fill="#768BA7"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80 40.25C80 40.6642 79.6642 41 79.25 41H36.75C36.3358 41 36 40.6642 36 40.25C36 39.8358 36.3358 39.5 36.75 39.5H79.25C79.6642 39.5 80 39.8358 80 40.25Z"
                fill="#768BA7"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M56 44.75C56 45.1642 55.6642 45.5 55.25 45.5H36.75C36.3358 45.5 36 45.1642 36 44.75C36 44.3358 36.3358 44 36.75 44H55.25C55.6642 44 56 44.3358 56 44.75Z"
                fill="#768BA7"
              />
            </g>
            <g clipPath="url(#clip4_61055_74235)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80 22.75C80 23.1642 79.6642 23.5 79.25 23.5H36.75C36.3358 23.5 36 23.1642 36 22.75C36 22.3358 36.3358 22 36.75 22H79.25C79.6642 22 80 22.3358 80 22.75Z"
                fill="#768BA7"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M68 27.25C68 27.6642 67.6642 28 67.25 28H36.75C36.3358 28 36 27.6642 36 27.25C36 26.8358 36.3358 26.5 36.75 26.5H67.25C67.6642 26.5 68 26.8358 68 27.25Z"
                fill="#768BA7"
              />
            </g>
            <g clipPath="url(#clip5_61055_74235)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80 53.25C80 53.6642 79.6642 54 79.25 54H36.75C36.3358 54 36 53.6642 36 53.25C36 52.8358 36.3358 52.5 36.75 52.5H79.25C79.6642 52.5 80 52.8358 80 53.25Z"
                fill="#768BA7"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M56 57.75C56 58.1642 55.6642 58.5 55.25 58.5H36.75C36.3358 58.5 36 58.1642 36 57.75C36 57.3358 36.3358 57 36.75 57H55.25C55.6642 57 56 57.3358 56 57.75Z"
                fill="#768BA7"
              />
            </g>
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 22.75C20 23.1642 19.6642 23.5 19.25 23.5H8.75C8.33579 23.5 8 23.1642 8 22.75C8 22.3358 8.33579 22 8.75 22H19.25C19.6642 22 20 22.3358 20 22.75Z"
            fill="#E8EFF7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 27.25C16 27.6642 15.6642 28 15.25 28H8.75C8.33579 28 8 27.6642 8 27.25C8 26.8358 8.33579 26.5 8.75 26.5H15.25C15.6642 26.5 16 26.8358 16 27.25Z"
            fill="#E8EFF7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 31.75C20 32.1642 19.6642 32.5 19.25 32.5H8.75C8.33579 32.5 8 32.1642 8 31.75C8 31.3358 8.33579 31 8.75 31H19.25C19.6642 31 20 31.3358 20 31.75Z"
            fill="#E8EFF7"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 36.25C16 36.6642 15.6642 37 15.25 37H8.75C8.33579 37 8 36.6642 8 36.25C8 35.8358 8.33579 35.5 8.75 35.5H15.25C15.6642 35.5 16 35.8358 16 36.25Z"
            fill="#E8EFF7"
          />
          <circle cx="9.5" cy="9.5" r="1.5" fill="#E8EFF7" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_61055_74235">
          <path
            d="M0 6C0 2.68629 2.68629 0 6 0H90C93.3137 0 96 2.68629 96 6V58C96 61.3137 93.3137 64 90 64H6C2.68629 64 0 61.3137 0 58V6Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_61055_74235">
          <rect
            width="80"
            height="80"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
        <clipPath id="clip2_61055_74235">
          <rect
            width="56"
            height="73"
            fill="white"
            transform="translate(30 16)"
          />
        </clipPath>
        <clipPath id="clip3_61055_74235">
          <rect
            width="44"
            height="10.5"
            fill="white"
            transform="translate(36 35)"
          />
        </clipPath>
        <clipPath id="clip4_61055_74235">
          <rect
            width="44"
            height="6"
            fill="white"
            transform="translate(36 22)"
          />
        </clipPath>
        <clipPath id="clip5_61055_74235">
          <rect
            width="44"
            height="6"
            fill="white"
            transform="translate(36 52.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
